import React, { Component } from "react";
import axios from "axios";
import settings from "client.settings.json";
import "./breakTheGlassPage.css";
import { translate } from "reducers/i18n";
import "react-phone-number-input/style.css";
import { connect } from "react-redux";
import { PageComponent } from "components/page";
import { getMappings } from "pages/getPageTemplatesMappings";

class BreakTheGlassPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: "",
      reason: "",
      messageIdIsValid: false,
      addressIdIsValid: false,
      numberIsAddToAddress: false,
      errorcode: null,
      retry: null,
      phoneNumberIsPossible: false,
      phoneNumberIsValid: false,
      phoneNumberHasFocus: false,
      reasonIsValid: false,
      breaktheglassIsPossible: false,
      breaktheglassIsDone: false,
      otherMessages: 0,
      includeOtherMessages: false,
      mappings: {},
      placeholder: "",
      accentColor: ""
    };
  }

  componentDidMount() {
    this.checkBreaktheglassIsPossible();
    if (this.props.location.hash) {
      const nonce = this.props.location.hash.substring(1);
      this.setState({ nonce });
    }
    getMappings("breaktheglass", this.props.match.params.tenantId)
      .then((mappings) => {
        this.setState({ 
          mappings: mappings, 
          placeholder: mappings?.E_DELIVERY_BTG_PAGE?.placeholder?.replace(/<\/?[^>]+(>|$)/g, "") || "" })
      })
      .catch((error) => console.log(error));

      
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      getMappings("breaktheglass", this.props.match.params.tenantId)
        .then((mappings) => this.setState({ mappings: mappings }))
        .catch((error) => console.log(error));
    }
    const header = document.querySelector(".panelHeader");
    if (!header) return;

    const accentColor = window.getComputedStyle(header).backgroundColor;
    if (accentColor !== this.state.accentColor) {
      this.setState({ accentColor });
    }
  }

  stripHtml = (input) => input.replace(/<\/?[^>]+(>|$)/g, "");

  render() {
    const btnFunctions = {
      E_DELIVERY_BTG_PAGE: [this.doBreakTheGlass],
    };

    return (
      <div className="BreakTheGlassPagePage panel">
        {(() => {
          if (this.state.loading)
            return (
              <div className="panelContent body_fontFamily">
                <p>{translate("_isLoading")}...</p>
              </div>
            );
          else if (this.state.breaktheglassIsDone)
            return (
              <PageComponent
                content={this.state.mappings["E_DELIVERY_BTG_PAGE_CONFIRMED"]}
              />
            );
          else if (this.state.breaktheglassIsPossible)
            return (
              <PageComponent
                content={this.state.mappings["E_DELIVERY_BTG_PAGE"]}
                btnFunctions={btnFunctions["E_DELIVERY_BTG_PAGE"]}
                disabled={!this.state.reasonIsValid}
              >
                <div
                  className={`${
                    this.state.phoneNumberIsValid
                      ? "phoneNumberIsValid"
                      : "phoneNumberIsNotValid"
                  } ${
                    this.state.phoneNumberHasFocus
                      ? "phoneNumberHasFocus"
                      : "phoneNumberHasNoFocus"
                  } ${
                    this.state.phone?.length
                      ? "phoneNumberNotEmpty"
                      : "phoneNumberEmpty"
                  }`}
                >
                  <textarea
                    className="reason mb-3"
                    autoFocus={true}
                    type="text"
                    enterkeyhint={translate("_submit")}
                    key="code"
                    placeholder={this.state.placeholder}
                    value={this.state.reason}
                    onChange={(e) => {
                      this.setReason(e.target.value || "");
                    }}
                  />

                  {this.state.otherMessages > 0 && (
                    <div className="border-top border-bottom py-3 mb-3" style={{
                          background: this.state.accentColor ? `rgb(${this.state.accentColor.match(/\d+/g).join(" ")} / 3%)` : '#cccccc1f',
                          margin: "0 -1rem",
                          padding: "0 1rem",
                    }}>
                      {translate(this.state.otherMessages === 1
                        ? "_breaktheglass_other_messages_single"
                        : "_breaktheglass_other_messages_multiple"
                      ).replace(
                        "{count}", this.state.otherMessages
                      )}
                      <label className="d-flex align-items-start mt-2 pl-1">
                        <input
                          type="checkbox"
                          className="mr-2 mt-1"
                          checked={this.state.includeOtherMessages}
                          style={{ accentColor: this.state.accentColor }}
                          onChange={(event) =>
                            this.setState({
                              includeOtherMessages: event.target.checked,
                            })
                          }
                        />
                        <div className="">
                          {translate(this.state.otherMessages === 1
                            ? "_breaktheglass_include_all_single"
                            : "_breaktheglass_include_all_multiple"
                          )}
                          <div className="small text-muted">
                            {translate(this.state.otherMessages === 1
                              ? "_breaktheglass_notification_note_single"
                              : "_breaktheglass_notification_note_multiple"
                            ).replace(
                              "{count}", this.state.otherMessages
                            )}
                          </div>
                        </div>
                      </label>
                    </div>
                  )}

                  {this.state.errorcode && (
                    <span className="errorcode" id="errorcode">
                      {translate(this.state.errorcode)}
                    </span>
                  )}
                </div>
              </PageComponent>
            );
          else if (this.state.errorcode === "_error_noAccess")
            return (
              <PageComponent
                content={{
                  ...this.state.mappings["E_DELIVERY_BTG_PAGE"],
                  body: translate(this.state.errorcode),
                }}
                disabled={true}
              />
            );
          else if (this.state.errorcode) {
            return (
              <PageComponent
                content={this.state.mappings["E_DELIVERY_BTG_PAGE_PERFORMED"]}
              />
            );
          }
        })()}
      </div>
    );
  }

  setReason = (reason) => {
    console.log(reason);
    this.setState({ reason, reasonIsValid: reason.length > 5 });
  };

  checkBreaktheglassIsPossible = () => {
    this.setState({ loading: true });
    axios({
      url: `${settings.api}/api/public/message/${this.props.match.params.messageId}/breaktheglass`,
      method: "get",
    }).then(
      (response) => {
        this.setState({ loading: false });
        if (response.data.breaktheglassIsPossible)
          this.setState({
            breaktheglassIsPossible: response.data.breaktheglassIsPossible,
            otherMessages: response.data.otherMessages || 0,
            includeOtherMessages: false,
          });
        if (response.data.errorcode)
          this.setState({ errorcode: response.data.errorcode });
      },
      (error) =>
        this.setState({
          loading: false,
          error: error,
          retry: () => {
            this.checkBreaktheglassIsPossible();
          },
        })
    );
  };

  doBreakTheGlass = () => {
    this.setState({ loading: true });
    if (this.state.breaktheglassIsPossible || this.state.reasonIsValid) {
      axios({
        url: `${settings.api}/api/public/message/${this.props.match.params.messageId}/breaktheglass`,
        method: "put",
        data: {
          reason: this.state.reason,
          nonce: this.state.nonce,
          includeOtherMessages: this.state.includeOtherMessages,
        },
      }).then(
        (response) => {
          this.setState({ loading: false });
          if (response.data.breaktheglassIsPossible)
            this.setState({
              breaktheglassIsPossible: response.data.breaktheglassIsPossible,
            });
          if (response.data.errorcode)
            this.setState({ errorcode: response.data.errorcode });
          if (response.data.breaktheglassIsDone)
            this.setState({
              breaktheglassIsDone: response.data.breaktheglassIsDone,
            });
        },
        (error) =>
          this.setState({
            loading: false,
            error: error,
            retry: () => {
              this.doBreakTheGlass();
            },
          })
      );
    } else {
      this.setState({ loading: false });
    }
  };
}

//export default BreakTheGlassPage

const mapStateToProps = (state) => state.i18n;
export default connect(mapStateToProps)(BreakTheGlassPage);
